import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import {
  useGetStocksDataQuery,
  useGetCommoditiesDataQuery,
  useAddStockDataMutation,
  useUploadProcMediaMutation,
} from "./ProcurementApiSlice";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye,  faRotateLeft,
} from "@fortawesome/free-solid-svg-icons";


import AddIcon from "@mui/icons-material/Add";
import { AddAddressProcurement } from "./AddAddressProcurement";
import { toast } from "react-toastify";
import StockLocationDetails from "../StockLocationDetails";
import NoData from "features/MobileProcurement/NoData";
import {
  Card,
  Button,
  Grid,
  Typography,
  Box,
  useMediaQuery,
  Tooltip,Container
} from "@mui/material";
import SkeletonLoader from "./SkeletonLoader";
const steps = ["Create Stock", "Add Location"];

const ManageCommodity = ({
  user_id,
  userName,
  setActiveCard,
  UserData,
  activeCard,setActiveTabProject
}) => {
  const [addStock, setAddStock] = useState(false);
  const RolesFromToken = useSelector(selectCurrentRoles);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const { data: data, isLoading, refetch } = useGetStocksDataQuery(
    { user_id: user_id },
    { refetchOnMountOrArgChange: true }
  );
  const {
    data: getCommodity,
    refetch: refetchCommodity,
  } = useGetCommoditiesDataQuery({ user_id: user_id }, { skip: !addStock });
  const [addStockApi] = useAddStockDataMutation();
  const [stockData, setStocksData] = useState([]);
  const [CommodityData, setCommodityData] = useState([]);
  const [stockaddloading, setAddStockLoading] = useState(false);
  const [cropIdSelected, setCropIdSelected] = useState("");
  const [allowingEditing, setallowingEditing] = useState(false);
  const [addStockData, setAddedStock] = useState({
    crop_name: "",
    quality_parameters: "",
    price: "",
    user: "",
    unit_measurement: "",
    variety: "",
    season: "",
    year: "",
    price_quoted_at: "",
    quoted_type: "",
  });
  const isMobile = useMediaQuery("(max-width:600px)"); 

  const [activeStep, setActiveStep] = useState(1);
  const [fileUploadId, setFileUploadId] = useState("");
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");
  const [selectedfileSend, SetSelectedFileSend] = useState("");
  const [selectedfileSendDuplcate, SetSelectedFileSendDuplicate] = useState("");
  const [uploadProcMedia] = useUploadProcMediaMutation();
  const [stockId, setStockId] = useState("");
  const [showLocation, setShowLocation] = useState(false);
  const [stockQuantity, setStockQuantity] = useState("");
    const [isRefetching, setIsRefetching] = useState(false);
  
  useEffect(() => {
    if (addStock && user_id) {
      refetchCommodity();
    }
  }, [addStock, user_id, refetchCommodity]);
  useEffect(() => {
    const dataFromApi = data?.data ? data?.data : [];
    const paginationFromApi = data?.pagination?.page
      ? {
          page: data?.pagination?.page,
          pageCount: data?.pagination?.total_pages,
        }
      : pagination;

    setStocksData(dataFromApi);
    setPagination(paginationFromApi);
    if (getCommodity) {
      setCommodityData(getCommodity?.data);
    }
  }, [data, getCommodity, activeCard]);
  
  const handleClose = () => {
    setAddStock(false);
    setActiveStep(0);
    setAddedStock({
      crop_name: "",
      quality_parameters: "",
      price: "",
      user: "",
      variety: "",
      season: "",
      year: "",
      price_quoted_at: "",
      quoted_type: "",
    });
    setallowingEditing(false);
    setCropIdSelected("");
  };
  const handleCloseLocation = () => {
    setShowLocation(false);
  };
  const Unit = [
    { title: "Quintal", year: 1991 },
  ];
  const Season = [
    { title: "Rabi", year: 1990 },
    { title: "Kharif", year: 1991 },
    { title: "Zaid", year: 1992 },
  ];
  const Year = [
    { title: 2025, year: 1989 },

    { title: 2024, year: 1990 },
    { title: 2023, year: 1991 },
    { title: 2022, year: 1991 },
    { title: 2021, year: 1991 },
    { title: 2020, year: 1991 },
  ];
  const PriceQuoted = [
    { title: "Warehouse", year: 1990 },
    { title: "TruckLoad", year: 1991 },
  ];
  const handleChange = (name) => (e, value) => {
    if (
      name === "unit_measurement" ||
      name === "season" ||
      name === "year" ||
      name === "quoted_type"
    ) {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else if (name === "crop_name") {
      setAddedStock({
        ...addStockData,
        [name]: value,
      });
    } else {
      setAddedStock({
        ...addStockData,
        [e.target.name]: e.target.value,
      });
    }
    if (name === "crop_name") {
      const filteredData = CommodityData?.find((item) => item.name === value);
      setCropIdSelected(filteredData?.code);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAddStockLoading(true);
    let payload;
    if (!allowingEditing) {
      payload = {
        crop_name: addStockData.crop_name,
        price: parseInt(addStockData.price),
        user: RolesFromToken.preferred_username,
        crop_id: cropIdSelected,
        unit_measurement: addStockData.unit_measurement,
        variety: addStockData.variety,
        season: addStockData.season,
        year: addStockData.year,
        quoted_type: addStockData.quoted_type,
      };
    } else {
      payload = {
        crop_name: addStockData.crop_name,
        price: addStockData.price,
        user: RolesFromToken.preferred_username,
        crop_id: cropIdSelected,
        unit_measurement: addStockData.unit_measurement,
        updated_by_id: user_id,
        updated_by_name: userName,
        variety: addStockData.variety,
        season: addStockData.season,
        year: addStockData.year,
        quoted_type: addStockData.quoted_type,
      };
    }

    addStockApi(payload)
      .unwrap()
      .then((data) => {
        if (data.status === 200 || data.status === 201) {
          toast.success("Stock Added Successfully");
          setActiveStep(1);
          setFileUploadId(data.data.id);
          setStockId(data.data.id);
          setStockQuantity(data.data.unit_measurement);
          setAddedStock({
            crop_name: "",
            price: "",
            unit_measurement: "",
            variety: "",
            season: "",
            year: "",
            price_quoted_at: "",
          });
          setAddStockLoading(false);
          refetch();
         
        }
      })
      .catch((error) => {
        swal("Oops Something went wrong !!", {
          icon: "warning",
          title: error.data.message,
          timer: 2000,
        });
        setAddStockLoading(false);
      });
  };

  const handleStockModal = (listVal, value) => {
    if (value) {
      setallowingEditing(true);
      SetSelectedFileSendDuplicate(
        listVal?.all_media?.length > 0 ? listVal?.all_media[0].file : ""
      );
      setAddedStock({
        crop_name: listVal.crop_name,
        price: listVal.price,
        unit_measurement: listVal.unit_measurement,
        variety: listVal.variety,
        season: listVal.season,
        year: listVal.year,
        address: listVal.address,
        quoted_type: listVal.quoted_type,
      });
      setStockQuantity(listVal.unit_measurement);

      setCropIdSelected(listVal.crop_id);
      setFileUploadId(listVal.id);
      setStockId(listVal.id);
    }
    setAddStock(true);
    setActiveStep(0);
  };

  const showLargeImage = (media) => {
    setImageInLightbox(media);
    setOpenLightBox(true);
  };
  const handleInputChange = (e) => {
    const file = e.target.files[0];
    SetSelectedFileSend(file);
  };
  const handleRefreshButton = async () => {
      setIsRefetching(true); // Set loading to true before refetching
      await refetch(); // Wait for API response
      setIsRefetching(false); // Turn off loading after refetch
    }
  
  return (
<Box >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row", // Keep items in a row
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
        className="p-lg-0 p-2"
      >
        <div className="heading-title mt-lg-0 mt-2">
          <h5
            className="text-warning"
            style={{
              fontSize: isMobile ? "9px" : "18px", // Smaller font size on mobile
            }}
          >
            MANAGE STOCKS
          </h5>
        </div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // Keep buttons in a row
            alignItems: "center", // Center align items
            mt: isMobile ? 0 : 0, // No margin top needed
          }}
        >
          {/* <Tooltip title="Add Commodity" arrow>
            <Button
              variant="contained"
              sx={{
                mr: 1, 
                backgroundColor: "#FF9800",
                color: "#FFFFFF",
                textTransform: "none",
                padding: isMobile ? "4px" : "6px 10px", 
                "&:hover": {
                  backgroundColor: "#F57C00",
                },
              }}

              onClick={() => {
                setAddCommodity(true);
              }}
            >
              {isMobile ? (
                <AddShoppingCartIcon />
              ) : (
                <>
                  <AddShoppingCartIcon />
                  &nbsp;&nbsp;Add Commodity
                </>
              )}
            </Button>
          </Tooltip> */}

          {/* <Tooltip title="Add Stock" arrow>
            <Button
              variant="outlined"
              sx={{
                backgroundColor: "transparent", 
                borderColor: "#FF9800", 
                color: "#FF9800", 
                textTransform: "none",
                padding: isMobile ? "4px" : "6px 10px",
                "&:hover": {
                  backgroundColor: "#FF9800", 
                  color: "#FFFFFF", 
                },
              }}
              onClick={() => handleStockModal("", false)}

            >
              {isMobile ? (
                <AddIcon />
              ) : (
                <>
                  <AddIcon /> &nbsp;Add Stock
                </>
              )}
            </Button>
          </Tooltip> */}
                <Tooltip title="Add Commodity" arrow>
            <Button
              variant="contained"
              className="buttonOrangeDefaultColor"
              onClick={() => handleStockModal("", false)}
            >
              {isMobile ? (
                <AddIcon />
              ) : (
                <>
                  <AddIcon />
                  &nbsp;&nbsp;Add Stock
                </>
              )}
            </Button>
            
          </Tooltip> 
          <Button
              variant="contained"
              onClick={() => handleRefreshButton()}

              className="bg-transparent text-black mx-2 p-2"
              style={{
                border: "1px solid #829999",
                color: "#343737",
              }}
            >
             
             <FontAwesomeIcon icon={faRotateLeft} />

              
              
            </Button>
        </Box>
      </Box>
      {isLoading || isRefetching ? (
        <SkeletonLoader />
      ) : stockData?.length > 0 ? (
        <Grid container spacing={2} style={{  backgroundColor:"#ebeef380",
          border:"1px solid #ebeef380"}} className="mt-0 mt-lg-2 p-lg-0">
          {/* {stockData.slice(0, displayLimit).map((trade) => { */}
          {stockData.map((trade) => {

            const totalPrice = trade.price * trade.quantity;
            return (
              <Grid item xs={12} sm={6} md={4} lg={4} key={trade.id}>
                <Card
                  sx={{
                    p: 3,
                    borderRadius: "8px",
                    border: "1px solid rgba(235, 239, 247, 0.8)",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
                      transform: "translateY(-2px)",
                    },
                  }}
                  className="mb-2"

                >
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Box
                      component="img"
                      src={trade.crop_url || "default-image-url.jpg"}
                      alt={trade.crop_name}
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        objectFit: "cover",
                        mr: 2,
                      }}
                    />
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#052f5f",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {trade.crop_name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#a1a1a1" }}>
                        Created on:{" "}
                        {new Date(trade.created_at).toLocaleDateString()}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#69829f" }}>
                      Variety:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", color: "#052f5f" }}
                    >
                      {trade.variety}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#69829f" }}>
                      Updated On:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", color: "#052f5f" }}
                    >
                      {new Date(trade.updated_at).toLocaleDateString()}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" sx={{ color: "#69829f" }}>
                      Quantity:
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", color: "#052f5f" }}
                    >
                      {trade.quantity} {trade.unit_measurement}
                    </Typography>
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      color: "#69829f",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <span>
                      Price:{" "}
                      <strong style={{ color: "#052f5f" }}>
                        ₹{trade.price} / unit
                      </strong>
                    </span>
                    <span>
                      Total:{" "}
                      <strong style={{ color: "#052f5f" }}>
                        ₹{totalPrice}
                      </strong>
                    </span>
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      className="buttonOrangeDefaultColor"
                      
                      onClick={() => handleStockModal(trade, true)}

                    >
                      <FontAwesomeIcon
                        icon={faEdit}
                        style={{ marginRight: "5px" }}
                      />
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{
                        backgroundColor: "transparent", // Transparent background for outlined button
                        borderColor: "#FF9800", // Same orange color for border
                        color: "#FF9800", // Orange text
                        textTransform: "none",
                        padding: isMobile ? "4px" : "3px 10px", // Smaller padding on mobile
                        "&:hover": {
                          backgroundColor: "#FF9800", // Fill with orange on hover
                          color: "#FFFFFF", // Change text to white on hover
                        },
                      }}
                      onClick={() => {
                        setStockId(trade.id);
                        setShowLocation(true);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faEye}
                        style={{ marginRight: "5px" }}
                      />
                      View Location
                    </Button>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <NoData val="Stock" />
      )}

    
<Modal show={addStock} onHide={handleClose} size={"md"}>
        <Modal.Header closeButton className="">
          <Modal.Title className="fw-bold text-primary">
            &nbsp;&nbsp; {allowingEditing ? "Update" : "Add"} Stock
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ width: "100%", marginTop: "-2px" }}>
          <Container maxWidth="xm">
            <Grid container direction="column" alignItems="center" spacing={2}>
              <Grid item xs={12}>
                {activeStep === 0 && (
                  <form onSubmit={handleSubmit}>
                    <div className="row mt-3">
                      <div className="col-lg-12  mb-3">
                        <Autocomplete
                          id="free-solo-2-demo"
                          name="crop_name"
                          value={addStockData.crop_name}
                          disabled={allowingEditing ? true : false}
                          disableClearable
                          onChange={handleChange("crop_name")}
                          options={CommodityData?.map((option) => option.name)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Commodity"
                              InputLabelProps={{ shrink: true }}
                              size="small"
                              required
                              InputProps={{
                                ...params.InputProps,
                                type: "search",

                              
                              }}
                            />
                          )}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1">
                        <TextField
                          id="variety"
                          label="Variety"
                          name="variety"
                          value={addStockData.variety}
                          required
                          size="small"
                          onChange={handleChange("variety")}
                          multiline
                          maxRows={2}
                          style={{ width: "100%" }}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1 ">
                        <Autocomplete
                          id="unit_measurement"
                          name="unit_measurement"
                          disableClearable
                          value={addStockData.unit_measurement}
                          onChange={handleChange("unit_measurement")}
                          options={Unit?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Unit"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                               
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-6  mb-3 mt-1">
                        <TextField
                          id="price"
                          label="Price/Unit (Rs)"
                          name="price"
                          value={addStockData.price}
                          required
                          size="small"
                          multiline
                          maxRows={2}
                          onKeyPress={(event) => {
                            if (!/\d/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={handleChange("price")}
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                      <div className="col-lg-6 mb-3 mt-1">
                        <Autocomplete
                          id="quoted_type"
                          name="quoted_type"
                          disableClearable
                          value={addStockData.quoted_type}
                          onChange={handleChange("quoted_type")}
                          options={PriceQuoted?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Price Estimated For"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                               
                              }}
                            />
                          )}
                        />
                      </div>

                      <div className="col-lg-6 mb-3 mt-1">
                        <Autocomplete
                          id="year"
                          name="year"
                          disableClearable
                          value={addStockData.year}
                          onChange={handleChange("year")}
                          style={{ width: "100%" }}
                          options={Year?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Year"
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                                
                              }}
                            />
                          )}
                        />
                      </div>
                      <div className="col-lg-6  mb-3 mt-1">
                        <Autocomplete
                          id="season"
                          name="season"
                          disableClearable
                          value={addStockData.season}
                          style={{ width: "100%" }}
                          size="small"
                          onChange={handleChange("season")}
                          options={Season?.map((option) => option.title)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Season"
                              InputLabelProps={{ shrink: true }}
                              required
                              InputProps={{
                                ...params.InputProps,
                                type: "search",
                               
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>

                    <div className="mt-4 mb-5">
                      {allowingEditing ? (
                        <Button
                          variant="contained"
                          className="float-end mx-2 mb-2"
                          color="primary"
                          size="small"
                          onClick={() => setActiveStep(1)}
                        >
                          Update Location
                        </Button>
                      ) : (
                        ""
                      )}
                      <Button
                        variant="contained"
                        className="float-end mx-2 mb-2"
                        color="success"
                        type="submit"
                        size="small"
                      >
                        Submit &nbsp;
                        {stockaddloading ? <Spinner size="sm" /> : ""}
                      </Button>
                    </div>
                  </form>
                )}
                {activeStep === 1 && (
                  <>
                    <div>
                      <AddAddressProcurement
                        stockId={stockId}
                        setStockId={setStockId}
                        UserData={UserData}
                        setActiveStep={setActiveStep}
                        refetch={refetch}
                        setActiveCard={setActiveCard}
                        allowingEditing={allowingEditing}
                        stockQuantity={stockQuantity}
                        RolesFromToken={RolesFromToken}
                        setAddStock={setAddStock}
                        setActiveTabProject={setActiveTabProject}
                      />
                    </div>
                  </>
                )}
              </Grid>
              {/* <Grid item xs={12} className="mt-3">
                {activeStep > 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleClose}
                    size="small"
                    style={{ float: "right" }}
                  >
                    Skip
                  </Button>
                )}
              </Grid> */}
            </Grid>
          </Container>
        </Modal.Body>
      </Modal>
      <Modal
        show={showLocation}
        onHide={handleCloseLocation}
        size="xl"
        centered
        dialogClassName="smooth-modal"
      >
        <Modal.Header closeButton className="">
          <Modal.Title className="fw-bold text-primary">
            Stock Updation Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "10px 20px" }}>
          <StockLocationDetails stockId={stockId} />
        </Modal.Body>
        <Modal.Footer className="">
          <Button
            variant="contained"
            className="float-end mx-2"
            color="primary"
            size="small"
            onClick={handleCloseLocation}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
};

export default ManageCommodity;
